/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reserve Clubhouse Request Schema
 * @export
 * @interface ReserveClubhouseRequest
 */
export interface ReserveClubhouseRequest {
    /**
     * Reservation Request ID
     * @type {string}
     * @memberof ReserveClubhouseRequest
     */
    id: string;
    /**
     * Account ID of the requester
     * @type {string}
     * @memberof ReserveClubhouseRequest
     */
    requestedBy: string;
    /**
     * Begin date of the reservation
     * @type {Date}
     * @memberof ReserveClubhouseRequest
     */
    beginDate: Date;
    /**
     * End date of the reservation
     * @type {Date}
     * @memberof ReserveClubhouseRequest
     */
    endDate: Date;
    /**
     * Notes about the reservation
     * @type {string}
     * @memberof ReserveClubhouseRequest
     */
    notes: string;
    /**
     * Status of the reservation request
     * @type {string}
     * @memberof ReserveClubhouseRequest
     */
    status: ReserveClubhouseRequestStatusEnum;
    /**
     * Response to the request
     * @type {string}
     * @memberof ReserveClubhouseRequest
     */
    response: string;
    /**
     * Date the request was created
     * @type {Date}
     * @memberof ReserveClubhouseRequest
     */
    createdDate: Date;
    /**
     * Date the request was last updated
     * @type {Date}
     * @memberof ReserveClubhouseRequest
     */
    updatedDate: Date;
    /**
     * True if the request has been deleted
     * @type {boolean}
     * @memberof ReserveClubhouseRequest
     */
    deleted: boolean;
}


/**
 * @export
 */
export const ReserveClubhouseRequestStatusEnum = {
    Approved: 'approved',
    Denied: 'denied',
    Pending: 'pending'
} as const;
export type ReserveClubhouseRequestStatusEnum = typeof ReserveClubhouseRequestStatusEnum[keyof typeof ReserveClubhouseRequestStatusEnum];


/**
 * Check if a given object implements the ReserveClubhouseRequest interface.
 */
export function instanceOfReserveClubhouseRequest(value: object): value is ReserveClubhouseRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('requestedBy' in value) || value['requestedBy'] === undefined) return false;
    if (!('beginDate' in value) || value['beginDate'] === undefined) return false;
    if (!('endDate' in value) || value['endDate'] === undefined) return false;
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('response' in value) || value['response'] === undefined) return false;
    if (!('createdDate' in value) || value['createdDate'] === undefined) return false;
    if (!('updatedDate' in value) || value['updatedDate'] === undefined) return false;
    if (!('deleted' in value) || value['deleted'] === undefined) return false;
    return true;
}

export function ReserveClubhouseRequestFromJSON(json: any): ReserveClubhouseRequest {
    return ReserveClubhouseRequestFromJSONTyped(json, false);
}

export function ReserveClubhouseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReserveClubhouseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'requestedBy': json['requested_by'],
        'beginDate': (new Date(json['begin_date'])),
        'endDate': (new Date(json['end_date'])),
        'notes': json['notes'],
        'status': json['status'],
        'response': json['response'],
        'createdDate': (new Date(json['created_date'])),
        'updatedDate': (new Date(json['updated_date'])),
        'deleted': json['deleted'],
    };
}

export function ReserveClubhouseRequestToJSON(value?: ReserveClubhouseRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'requested_by': value['requestedBy'],
        'begin_date': ((value['beginDate']).toISOString()),
        'end_date': ((value['endDate']).toISOString()),
        'notes': value['notes'],
        'status': value['status'],
        'response': value['response'],
        'created_date': ((value['createdDate']).toISOString()),
        'updated_date': ((value['updatedDate']).toISOString()),
        'deleted': value['deleted'],
    };
}

